import React from 'react'

import { classNames } from 'services/string'
import { CommonContactFormProps } from 'components/ContactForm/types'

import FormFields from 'components/ContactForm/FormFields'

const AlternativeVariant = ({ className, onSubmit, loading, marketingCampaignCode }: CommonContactFormProps) => {
  return (
    <div className={classNames(className, 'bg-gradient-to-r from-gray-900/10 to-gray-600/10 z-50 p-4 w-full rounded-2xl')}>
      <FormFields
        loading={loading}
        onSubmit={onSubmit}
        options={{
          textFieldVariant: 'filled',
          hideTextFieldLabels: true,
          contrastReferenceColor: 'var(--color-secondary-50)',
          buttonFullWidth: true,
          buttonLabel: 'Enviar informações',
        }}
        marketingCampaignCode={marketingCampaignCode}
      />
    </div>
  )
}

export default AlternativeVariant
